import { render, staticRenderFns } from "./container.vue?vue&type=template&id=3653acf8&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"
import style0 from "./container.vue?vue&type=style&index=0&id=3653acf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3653acf8",
  null
  
)

export default component.exports